// React
import React from "react";
import PropTypes from "prop-types";
// i18n
import { withNamespaces } from "react-i18next";

function TableFooter({
  currentPage,
  isBackButtonEnabled,
  isNextButtonEnabled,
  onNextButtonClick,
  onPreviousButtonClick,
  pageSize,
  totalRows,
  t
}) {
  return (
    <div className="dt-toolbar-footer">
      <div className="col-sm-6 col-xs-12 hidden-xs">
        <div aria-live="polite" className="dataTables_info" id="dt_basic_info" role="status">
          {t("modules.localization.register.authenticated.common.table.showingOf", {
            beginning: (currentPage - 1) * pageSize + 1,
            end: currentPage * pageSize > totalRows ? totalRows : currentPage * pageSize,
            total: totalRows
          })}
        </div>
      </div>
      <div className="col-xs-12 col-sm-6">
        <div className="dataTables_paginate paging_simple_numbers" id="dt_basic_paginate">
          <ul className="pagination">
            <li
              className={`paginate_button previous ${
                isBackButtonEnabled ? "cursor-pointer" : "disabled"
              }`}
              id="dt_basic_previous"
            >
              <a aria-controls="dt_basic" onClick={onPreviousButtonClick} tabIndex={0}>
                {t("modules.localization.register.authenticated.common.table.button.previous")}
              </a>
            </li>
            <li className="paginate_button active">
              <a aria-controls="dt_basic" tabIndex={0}>
                {currentPage}
              </a>
            </li>
            <li
              className={`paginate_button next ${
                isNextButtonEnabled ? "cursor-pointer" : "disabled"
              }`}
              id="dt_basic_next"
            >
              <a aria-controls="dt_basic" onClick={onNextButtonClick} tabIndex={0}>
                {t("modules.localization.register.authenticated.common.table.button.next")}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

TableFooter.defaultProps = {
  currentPage: 1,
  isBackButtonEnabled: false,
  isNextButtonEnabled: false,
  onNextButtonClick: () => {},
  onPreviousButtonClick: () => {},
  pageSize: 0,
  totalRows: 0
};

TableFooter.propTypes = {
  currentPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isBackButtonEnabled: PropTypes.bool,
  isNextButtonEnabled: PropTypes.bool,
  onNextButtonClick: PropTypes.func,
  onPreviousButtonClick: PropTypes.func,
  pageSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  t: PropTypes.func.isRequired,
  totalRows: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default withNamespaces()(TableFooter);
